import HorizontalCard from "../productCards/horizontalCard";
import VerticalCard from "../productCards/verticalCard";
import {CashbackCustomerProductView, ToggleGif} from "../../../assets/assets";
import {useEffect, useState} from "react";

export default function SectionComponent(props) {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 768);
        };

        checkMobile();
        window.addEventListener("resize", checkMobile);
        return () => window.removeEventListener("resize", checkMobile);
    }, []);

    return (
        <div className="my-20 space-y-4">
            <div className="text-black text-[64px] p-32 responsive-section" style={{backgroundColor: "#f5f5f7"}}>
                <div className="flex items-center justify-center">
                    <div>
                        <h1 className="my-8 text-center section-heading-c" style={{fontWeight: "600"}}>
                            Painless refunds.
                        </h1>

                        <div className="flex justify-center">
                            <div className="mt-20 w-4/5 space-y-4 section-inner">

                                <HorizontalCard
                                    // title="Store Credit Refunds instead of traditional refunds."
                                    title="Convert refunds into store credit."
                                    description="Keep revenue in your ecosystem while giving customers flexibility to choose their next purchase. Instead of waiting days for a bank refund, customers receive instant credit to use on anything in your store. Plus, you can add a 10% bonus for choosing this option."
                                    imageSource="https://www.apple.com/v/app-store/b/images/overview/discovery_stories__fs202x3qvqye_large_2x.jpg"
                                    imagePosition={isMobile ? "top" : "right"}
                                />

                                <div className="flex space-x-4 responsive-card-group">
                                    <div style={{maxWidth: '49%'}}>
                                        <VerticalCard
                                            title="Over 65% of customers spend more with their store credit refund."
                                            imagePosition="bottom"
                                            superSizeTitle={true}
                                            cardColor="black"
                                        />
                                    </div>

                                    <div style={{maxWidth: '49%'}}>
                                        <VerticalCard
                                            title="Pay-to-play or free entry."
                                            description="Monetize exclusivity. Offer curated membership tiers that customers can buy through your Shopify store. Or add customers to membership tiers ad hoc."
                                            imageSource={CashbackCustomerProductView}
                                            imagePosition="bottom"
                                        />
                                    </div>
                                </div>

                                <HorizontalCard
                                    // title="Explore in-app events like movie premieres, gaming competitions, and livestreams."
                                    // title="Stop quiting things that have huge long-term potential because they make you feel uncomfortable in the present moment."
                                    title="Don't abandon cashback rewards just because they take patience. What feels slow today becomes tomorrow's financial win."
                                    description="Use any of our pre-built cashback templates that convert 30% better than generic offers."
                                    imageSource="https://www.apple.com/v/app-store/b/images/overview/discovery_in_app__e2uo3q050wqe_large_2x.jpg"
                                    imagePosition="top"
                                />

                                <div className="flex space-x-4 responsive-card-group">
                                    <div style={{maxWidth: '49%'}}>
                                        <VerticalCard
                                            title="Easily search across all membership activites."
                                            description="Our comprehensive search feature offers suggestions and helpful hints, and provides results with in‑line video previews, editorial stories, tips and tricks, and lists."
                                            imageSource="https://www.apple.com/v/app-store/b/images/overview/icon_search__d0w979yulru6_large_2x.png"
                                            imagePosition="top"
                                            imageHeight="150px"
                                            imageMargin={isMobile ? undefined : "176px"}
                                        />
                                    </div>

                                    <div style={{maxWidth: '49%'}}>
                                        <VerticalCard
                                            title="Recurring Credit &nbsp;"
                                            imageSource={ToggleGif}
                                            description="Easy Toggle allows for seamless on/off switching without interrupting business flow."
                                            imagePosition="top"
                                            superSizeTitle={!isMobile}
                                        />
                                    </div>
                                </div>

                                <div className="flex space-x-4 responsive-card-group">
                                    <div style={{maxWidth: '49%'}}>
                                        <VerticalCard
                                            title="12,500+ storefronts in 40+ languages."
                                            // description="Translates to any language"
                                            cardColor="black"
                                            superSizeTitle={true}
                                        />
                                    </div>

                                    <div style={{maxWidth: '49%'}}>
                                        <VerticalCard
                                            title="Priority queue on new product launches."
                                            cardColor="blue"
                                            superSizeTitle={true}
                                        />
                                    </div>
                                </div>

                                <HorizontalCard
                                    title="Get the details on every app."
                                    description="App product pages give you the information you need when deciding what to download. From more videos to rankings and reviews, there are loads of ways to help you pick the app that’s right for you."
                                    imageSource="https://www.apple.com/v/app-store/b/images/overview/discovery_details__bguw9nfi7w9u_large_2x.jpg"
                                    imagePosition={isMobile ? "top" : "left"}
                                />
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div className="text-black text-[64px] p-32 responsive-section" style={{backgroundColor: "#f5f5f7"}}>
                <div className="flex items-center justify-center">
                    <div>
                        <h1 className="my-8 text-center section-heading-c" style={{fontWeight: "600"}}>
                            <div>Cashback is a Shopify retention tool.</div>
                            <div>Functioning as an engagement engine.</div>
                        </h1>

                        <div className="flex justify-center">
                            <div className="mt-20 w-4/5 space-y-4 section-inner">

                                <HorizontalCard
                                    // title="Security for every app. At every level."
                                    title="Recurring Credit"
                                    description="We ensure that apps come from known sources, are free of known malware, and haven’t been tampered with at the time of installation or launch."
                                    imageSource="https://www.apple.com/v/app-store/b/images/overview/privacy_security__c7ffaiitglg2_large_2x.jpg"
                                    imagePosition={isMobile ? "top" : "right"}
                                    superSizeTitle={true}
                                />

                                <div className="flex space-x-4 responsive-card-group">
                                    <div style={{maxWidth: '49%'}}>
                                        <VerticalCard
                                            title="100% of apps are automatically screened for known malware."
                                            cardColor="blue"
                                        />
                                    </div>

                                    <div style={{maxWidth: '49%'}}>
                                        <VerticalCard
                                            title="Over 16K apps use Apple health technologies like HealthKit, CareKit, and ResearchKit designed to protect patient privacy."
                                            cardColor="black"
                                        />
                                    </div>
                                </div>


                                <HorizontalCard
                                    title="Elite Membeships"
                                    description="Each app is required to ask for your permission so you can choose what data to share..."
                                    imageSource="https://www.apple.com/v/app-store/b/images/overview/privacy_data__fopy0xxbbkuy_large_2x.jpg"
                                    imagePosition={isMobile ? "top" : "left"}
                                />

                                <div className="flex space-x-4 responsive-card-group">
                                    <div style={{maxWidth: '49%'}}>
                                        <VerticalCard
                                            title="Always fresh. Always actionable."
                                            description="Members automatically receive recurring credits monthly or at your chosen frequency."
                                            imageSource="https://www.apple.com/v/app-store/b/images/overview/trust_guidelines__dcbhrjxc09km_large_2x.jpg"
                                            imagePosition={isMobile ? "top" : "bottom"}
                                            imageHeight= "330px"
                                            imageMargin="80px"
                                        />
                                    </div>

                                    <div style={{maxWidth: '49%'}}>
                                        <VerticalCard
                                            title="Every week, over 500 dedicated experts around the world review over 100K apps."
                                            // imageSource="https://www.apple.com/v/app-store/b/images/overview/icon_family_sharing__c0yp60522tm6_large_2x.png"
                                            imagePosition="top"
                                            superSizeTitle={true}
                                            cardColor="black"
                                        />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>

            {/* Mobile-Only Responsive Styles */}
            <style>
                {`
                @media (max-width: 767px) {
                    .responsive-section {
                        font-size: 28px !important;
                        padding: 28px !important;
                    }

                    .section-heading-c {
                        font-size: 48px !important;
                        line-height: 1.3 !important;
                    }

                    .section-inner {
                        width: 100% !important;
                        margin-top: 2rem !important;
                    }

                    .responsive-card-group {
                        flex-direction: column !important;
                        gap: 1.5rem !important;
                    }

                    .responsive-card-group > div {
                        max-width: 100% !important;
                        margin-left: 0 !important;
                    }
                }
                `}
            </style>
        </div>
    );
}
